const getters = {
  getList: state => state.all,
  getPaginationCheck: state => state.disablePagination,
  getPage: state => state.page,
  getFilter: state => state.filter,
  getMaterialList: state => ((state.requestDetails) ? state.requestDetails.materialsData : {}),
  getReturnReasonOptions: state => ((state.requestDetails) ? state.requestDetails.returnReasonOptions : []),
  getRequestInfo: state => ((state.requestDetails && state.requestDetails.requestDetails) ? state.requestDetails.requestDetails : {}),
  getMasterVehicleList: state => state.masterVehicleList,
  getMasterTransporters: state => state.masterTransporterList,
  getNoFreightTransporters: state => state.noFreightTransporterList,
  getMdmGateList: state => state.mdmGateList,
  getAutopulateInfo: state => ((state.requestDetails && state.requestDetails.detailsToAutoPopulate) ? state.requestDetails.detailsToAutoPopulate : null),
};
export default getters;
